import React from 'react'
import { FlexRow, Icon, Text } from 'elements'

export default function ErrorBanner(props) {
  const { message, styleProps = { bg: 'secondary.0', color: 'background.0' } } = props
  return (
    <FlexRow
      justifyContent="center"
      alignItems="center"
      borderRadius="small"
      flex="0 0 auto"
      px="xlarge"
      py="medium"
      {...styleProps}
    >
      <Icon name="info-circle" size="medium" mr="xlarge" />
      <Text color="inherit" fontWeight="bold">
        {message}
      </Text>
    </FlexRow>
  )
}
